export const Google = ({ className }: { className?: string }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="60"
		height="60"
		viewBox="0 0 60 60"
		fill="none"
		className={className}
	>
		<path
			d="M32.0046 22.6453C34.2593 22.6453 35.7802 23.6186 36.6474 24.432L40.0361 21.1254C37.9548 19.1921 35.2465 18.0055 32.0046 18.0055C27.3085 18.0055 23.2527 20.6987 21.2782 24.6185L25.1605 27.6318C26.1344 24.7385 28.8294 22.6453 32.0046 22.6453Z"
			fill="#EA4335"
		/>
		<path
			d="M43.5341 30.2708C43.5341 29.2842 43.454 28.5642 43.2805 27.8176H32.0071V32.2707H38.6245C38.491 33.3773 37.7706 35.044 36.1696 36.1638L39.9586 39.0972C42.2267 37.0038 43.5341 33.924 43.5341 30.2708Z"
			fill="#4285F4"
		/>
		<path
			d="M25.1765 32.3796C24.923 31.6329 24.7762 30.8329 24.7762 30.0063C24.7762 29.1796 24.923 28.3797 25.1631 27.633L21.2807 24.6198C20.467 26.2464 20 28.073 20 30.0063C20 31.9395 20.467 33.7662 21.2807 35.3927L25.1765 32.3796Z"
			fill="#FBBC05"
		/>
		<path
			d="M32.0107 42.0062C35.2526 42.0062 37.9742 40.9396 39.9621 39.0996L36.1731 36.1664C35.1592 36.873 33.7984 37.3664 32.0107 37.3664C28.8355 37.3664 26.1405 35.273 25.18 32.3799L21.2976 35.393C23.2721 39.313 27.3145 42.0062 32.0107 42.0062Z"
			fill="#34A853"
		/>
	</svg>
)
